import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "title title-builder"
}
const _hoisted_3 = { class: "row-wr" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "row-value" }
const _hoisted_6 = {
  key: 0,
  class: "row-value"
}
const _hoisted_7 = {
  key: 1,
  class: "row-value"
}
const _hoisted_8 = {
  key: 2,
  class: "row"
}
const _hoisted_9 = {
  key: 0,
  class: "row-value"
}
const _hoisted_10 = {
  key: 1,
  class: "row-value"
}
const _hoisted_11 = {
  key: 0,
  class: "row-value"
}
const _hoisted_12 = {
  key: 1,
  class: "row-value"
}
const _hoisted_13 = {
  key: 0,
  class: "row-value"
}
const _hoisted_14 = {
  key: 1,
  class: "row-value"
}
const _hoisted_15 = {
  key: 1,
  class: "row-value"
}
const _hoisted_16 = {
  key: 2,
  class: "row-value"
}
const _hoisted_17 = {
  key: 0,
  class: "row-value"
}
const _hoisted_18 = {
  key: 1,
  class: "row-value"
}
const _hoisted_19 = {
  key: 0,
  class: "content-documents"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["blocks-wr", { 'block-width': $props.isBuilderView }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["block", { 'block-hidden': $props.isBuilderView }])
    }, [
      (!$props.isBuilderView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Lot Details"))
        : _createCommentVNode("", true),
      ($setup.isDesktop && $props.isBuilderView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Lot " + _toDisplayString($props.lot?.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-label" }, "Stage", -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString($props.lot.stageId.title), 1)
            ]))
          : _createCommentVNode("", true),
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["row", { secondary: !$props.isBuilderView }])
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Frontage", -1)),
              (!$props.isBuilderView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($props.lot.lotId.blockWidth ? `${$setup.formatPrice($props.lot.lotId.blockWidth, false)} m` : "Irregular"), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.lot.blockWidth ? `${$setup.formatPrice($props.lot.blockWidth, false)} m` : "Irregular"), 1))
            ], 2))
          : _createCommentVNode("", true),
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Size", -1)),
              (!$props.isBuilderView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.formatPrice($props.lot.lotId.size, false)) + " sqm", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.formatPrice($props.lot.size, false)) + " sqm", 1))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["row", { secondary: !$props.isBuilderView }])
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-label" }, "Size", -1)),
              (!$props.isBuilderView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.formatPrice($props.lot.lotId.size, false)) + " sqm", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.formatPrice($props.lot.size, false)) + " sqm", 1))
            ], 2)),
        ($props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["row", { secondary: $props.isBuilderView }])
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-label" }, "Frontage", -1)),
              (!$props.isBuilderView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($props.lot.lotId.blockWidth ? `${$setup.formatPrice($props.lot.lotId.blockWidth, false)} m` : "Irregular"), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($props.lot.blockWidth ? `${$setup.formatPrice($props.lot.blockWidth, false)} m` : "Irregular"), 1))
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { secondary: !$props.isBuilderView }])
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-label" }, "Price", -1)),
          ($props.estate.hidePrice)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row-value highlighted",
                onClick: $setup.toContact
              }, "Request pricing"))
            : (!$props.isBuilderView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.formatPrice($props.lot.lotId.price)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.formatPrice($props.lot.price)), 1))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { secondary: $props.isBuilderView }])
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-label" }, "Est. Registration", -1)),
          (!$props.isBuilderView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.formatDate($props.lot.lotId.registrationDate, "MMM YYYY")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.formatDate($props.lot.registrationDate, "MMM YYYY")), 1))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["row", { secondary: !$props.isBuilderView }])
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-label" }, "Status", -1)),
          (!$props.isBuilderView)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["badge", $setup.getLotStatusClass($props.lot.lotId.status)])
              }, _toDisplayString($props.lot.lotId.status), 3))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["badge", $setup.getLotStatusClass($props.lot.status)])
              }, _toDisplayString($props.lot.status), 3))
        ], 2)
      ])
    ], 2),
    (!$props.isBuilderView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          ($props.lot.lotId.documents && $props.lot.lotId.documents.length)
            ? (_openBlock(), _createBlock($setup["BuilderLotDocuments"], {
                key: 0,
                documents: $props.lot.lotId.documents
              }, null, 8, ["documents"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}